import { render } from "./TakEoutburger.vue?vue&type=template&id=1ccb3115"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/TakEoutburger.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1ccb3115"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1ccb3115', __exports__)) {
    api.reload('1ccb3115', __exports__)
  }
  
  module.hot.accept("./TakEoutburger.vue?vue&type=template&id=1ccb3115", () => {
    api.rerender('1ccb3115', render)
  })

}


export default __exports__